import { Box } from "@mui/material";
import { InsightsTable, TableColumn } from "../components/InsightsTable";
import {
  GrazingEventsByFieldData,
  useGrazingEventsByField,
} from "../hooks/useInsightsDashboardQueries";

const columns: TableColumn<GrazingEventsByFieldData>[] = [
  { key: "GrazingEvents.fieldName", label: "Field" },
  {
    key: "GrazingEvents.count",
    label: "Events",
    align: "right",
    format: (v) => String(Number(v)),
  },
  {
    key: "GrazingEvents.sumKgDmUsed",
    label: "Kg DM Used",
    align: "right",
    format: (v) =>
      Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 }),
  },
  {
    key: "GrazingEvents.avgFieldOnTime",
    label: "Avg Days On Field",
    align: "right",
    format: (v) => Number(v).toFixed(1),
  },
  {
    key: "GrazingEvents.avgDryMatterOutPerHectar",
    label: "Avg DM Out (kg/ha)",
    align: "right",
    format: (v) => Number(v).toFixed(0),
  },
];

export function GrazingManagementTab({ farmerGuid }: { farmerGuid?: string }) {
  const { data, isLoading } = useGrazingEventsByField(farmerGuid);
  const rows = data?.data ?? [];

  return (
    <Box>
      <InsightsTable
        title={`Grazing Events by Field (${new Date().getFullYear()})`}
        columns={columns}
        data={rows}
        isLoading={isLoading}
        getRowKey={(row) => row["GrazingEvents.fieldName"]}
      />
    </Box>
  );
}
